import { Document } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { ContentfulRichText as ContentfulRichTextContent } from '@silvertours/common-landingpages-view';

import { createOptions } from './options';
import { GridContainer } from './ContentfulRichText.styles';
import { HasTextStyleRules } from '../rules';

export const ContentfulRichText = ({
  content,
  rules,
  enableSnippetExtraction = true,
}: {
  content: ContentfulRichTextContent;
  rules?: HasTextStyleRules;
  enableSnippetExtraction?: boolean;
}) => {
  const document = content.text as unknown as Document;
  const options = createOptions(enableSnippetExtraction, rules, document);

  return (
    <GridContainer
      textStyle={rules?.textStyle}
      enableExtraction={enableSnippetExtraction}
    >
      {documentToReactComponents(document, options)}
    </GridContainer>
  );
};
